export const ratingValues = ["S", "A", "B", "C", ""];
export type RatingValue = typeof ratingValues[number];

export function isRatingValue(value: any): value is RatingValue {
  return typeof value === "string" && ratingValues.some(v => v === value);
}
